const useModalAssinarOperacaoHook = ({ onClose }) => {
  const dadosResumoOperacao = {
    aceitosQtd: 10,
    valorTotal: 50000.0,
    valorLiquido: 48500.0
  };

  const { aceitosQtd, valorTotal, valorLiquido } = dadosResumoOperacao;

  const formataValor = valor =>
    parseFloat(valor).toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    if (reason === 'escapeKeyDown') return;
    onClose();
  };

  return {
    formataValor,
    aceitosQtd,
    valorTotal,
    valorLiquido,
    handleClose
  };
};

export default useModalAssinarOperacaoHook;
